import React, { useState, useEffect } from "react";
import { useShifts } from "../../master/context/ShiftsContext";
import { API_URL } from "utils/constants";

const CreateSchedulePatternPage = ({ initialData, onSuccess, onError }) => {
  const { shifts } = useShifts();
  const isUpdateMode = initialData && Object.keys(initialData).length > 0;

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    details: [],
  });

  // Initialize form data
  useEffect(() => {
    if (isUpdateMode && initialData) {
      setFormData({
        name: initialData.name || "",
        description: initialData.description || "",
        details: initialData.details || [],
      });
    }
  }, [initialData, isUpdateMode]);

  // Create options from hooks data
  const shiftOptions = shifts.data?.map(shift => ({
    value: shift.id,
    label: shift.name
  })) || [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const addDetail = () => {
    setFormData(prev => ({
      ...prev,
      details: [...prev.details, { day_order: prev.details.length + 1, shift_id: "" }]
    }));
  };

  const removeDetail = (index) => {
    setFormData(prev => ({
      ...prev,
      details: prev.details.filter((_, i) => i !== index)
    }));
  };

  const updateDetail = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      details: prev.details.map((detail, i) =>
        i === index ? { ...detail, [field]: value } : detail
      )
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = {
        name: formData.name,
        description: formData.description,
        details: formData.details
      };

      const token = localStorage.getItem("token");
      const url = isUpdateMode
        ? `${API_URL}/ahr/schedule-patterns/${initialData.id}`
        : `${API_URL}/ahr/schedule-patterns`;

      const response = await fetch(url, {
        method: isUpdateMode ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(submitData),
      });

      const result = await response.json();

      if (response.ok) {
        onSuccess(result);
      } else {
        onError(result);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      onError(error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="d-flex flex-column">
      <div className="action-sheet-content flex-grow-1">
        {/* Name Field */}
        <div className="row mb-3 align-items-center">
          <label className="col-sm-4 col-form-label d-flex justify-content-end">
            Pattern Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter pattern name"
              required
            />
          </div>
        </div>

        {/* Description Field */}
        <div className="row mb-3 align-items-center">
          <label className="col-sm-4 col-form-label d-flex justify-content-end">
            Description:
          </label>
          <div className="col-sm-8">
            <textarea
              className="form-control"
              name="description"
              rows={3}
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter pattern description"
            />
          </div>
        </div>

        {/* Pattern Details */}
        <div className="row mb-3 align-items-start">
          <label className="col-sm-4 col-form-label d-flex justify-content-end">
            Pattern Details:
          </label>
          <div className="col-sm-8">
            <div className="pattern-details">
              {formData.details.map((detail, index) => (
                <div key={index} className="row mb-2 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Day {detail.day_order}</label>
                    <input
                      type="number"
                      className="form-control"
                      value={detail.day_order}
                      onChange={(e) => updateDetail(index, "day_order", parseInt(e.target.value))}
                      min="1"
                      max="7"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Shift</label>
                    <select
                      className="form-select"
                      value={detail.shift_id}
                      onChange={(e) => updateDetail(index, "shift_id", e.target.value)}
                    >
                      <option value="">Select shift</option>
                      {shiftOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <button
                      type="button"
                      className="btn btn-danger btn-sm w-100"
                      onClick={() => removeDetail(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={addDetail}
              >
                Add Day
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button type="submit" className="btn btn-primary btn-block">
          {isUpdateMode ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default CreateSchedulePatternPage;